import { render, staticRenderFns } from "./format-without-manage.vue?vue&type=template&id=1c1f079d&scoped=true"
import script from "./format-without-manage.vue?vue&type=script&lang=js"
export * from "./format-without-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1f079d",
  null
  
)

export default component.exports